import { render, staticRenderFns } from "./DivInput.vue?vue&type=template&id=c38f0514"
import script from "./DivInput.vue?vue&type=script&lang=ts"
export * from "./DivInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports